import {isDarkColor} from '@wix/panda-js-utils'
import {useContext} from 'react'
import {DetailsPageRuntimeContext} from '../components/runtime-context/context'

export const useColors = () => {
  const detailsPageRuntimeContext = useContext(DetailsPageRuntimeContext)

  const getActionColor = () =>
    detailsPageRuntimeContext.host.style.siteColors.find((color: any) => color.reference === 'color-8').value

  const getSecondRsvpButtonColor = () =>
    detailsPageRuntimeContext.host.style.styleParams.colors?.secondRsvpButtonBackgroundColor?.value || getActionColor()

  const darkColor = isDarkColor(getSecondRsvpButtonColor())

  return {
    darkColor,
  }
}
